
import OrderItem from "@/components/OrderItem.vue";
import moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    icone: String,
    imageUrl: String,
    idIcon: String,
    identifier: String,
    titulo: String,
    status: String,
    valor: Number,
    date: String,
    paymentStatus: String,
    paymentMethod: String,
    paymentStatusNumber: Number,
    click: Function,
    isFinished: Boolean,
    cancelled: Boolean,
    items: Array,
    itemsBody: Array,
    progress: Number,
    counter: Object,
    statusColor: String,
  },
  components: { OrderItem },
})
export default class ThreeOptionsListOrd extends Vue {
  counterItems: any = "";
  created() {
    if (this.$props.items.length > 2) {
      this.counterItems = parseInt(this.$props.items.length) - 1;
    }
  }

  iconColorExtrato(idIcon: any, icone: any) {
    setTimeout(function () {
      if (icone == "arrow_downward") {
        const el: HTMLElement | null = document.getElementById(idIcon);
        if (el) {
          el.className += " extrato-red";
        }
      } else {
        const el: HTMLElement | null = document.getElementById(idIcon);
        if (el) {
          el.className += " extrato-green";
        }
      }
    }, 1);
  }

  formatFirstDateTime(stringDate: string) {
    const momentDate: any = moment(stringDate);
    return momentDate.lang("pt-br").format("DD/MM/YYYY");
  }

  formatSecondDateTime(stringDate: string) {
    const momentDate: any = moment(stringDate);
    return momentDate.lang("pt-br").format("HH:mm");
  }
}
